export const GAME_TITLE = 'Bukvar 🇧🇦 ⚜'

export const WIN_MESSAGES = [
  '5/5!',
  'Sjedi petica!',
  'Ko je to, šta je to, kaži, kaži?',
  '"Ko drugom jamu kopa, riječ pogađa!" - Sokrat',
  'Dođoh, vidjeh, pogodih! - Mehmedalija Mak Dizdar',
  'Svaka čast! 🥳',
  'Super! 🎉',
  'Odlično! 😍',
  'Ma bravo! 🎉',
  'MA KO NAMA POGAĐA?!?!? 🤗',
  'DRAGI NAŠ VOKABULAR 🤗',
  'KO TO ZNA SVE RIJEČI?',
  'Rukama se gleda, slovima se pogađa! 🤗',
  'Igranje nije obavezno, ali nije ni kupanje!',
  'Pozovi 99 prijatelja da igraju i dobićeš vrijednu nagradu!',
  'Ko igra, zlo ne misli, a ne čini ni proljeće!',
  'Slovo po slovo, riječ po riječ, Istanbul je daleko, ali nije Beč!',
  'Podijeli rezultat sa omiljenim prijateljima na Viberu!',
  'Podijeli rezultat sa omiljenim prijateljima na Signalu!',
  'Bolje igraš od svih kolega, a bogme i kolegica!',
  'Ko je nama rječit??!?',
]
export const GAME_COPIED_MESSAGE = 'Rezultat kopiran, podijeli sa prijateljima'
export const ABOUT_GAME_MESSAGE = 'O igri'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Nedovoljno slova'
export const WORD_NOT_FOUND_MESSAGE = 'Riječ nije pronađena'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `Izgubio/la si, tražena riječ je ${solution}`
export const ENTER_TEXT = 'Pošalji'
export const DELETE_TEXT = '←'
export const STATISTICS_TITLE = 'Statistika'
export const GUESS_DISTRIBUTION_TEXT = 'Distribucija pokušaja'
export const NEW_WORD_TEXT = 'Nova riječ stiže za'
export const SHARE_TEXT = 'Podijeli'
export const TOTAL_TRIES_TEXT = 'Ukupno pokušaja'
export const SUCCESS_RATE_TEXT = 'Procenat uspješnosti'
export const CURRENT_STREAK_TEXT = 'Trenutni niz'
export const BEST_STREAK_TEXT = 'Najbolji niz'
export const SOLVE_TIME_TEXT = 'Riješeno za'
export const TODAY_TIME_TEXT = 'Današnje vrijeme'
export const BEST_TIME_TEXT = 'Najbolje vrijeme'
export const AVG_TIME_TEXT = 'Prosječno vrijeme'

export const TIME_TRACKING_CONSENT_TITLE = 'Mjerenje vremena'
export const TIME_TRACKING_CONSENT_BODY =
  'Bukvar sada može mjeriti koliko ti treba da pogodiš današnju riječ. Štoperica kreće s prvim slovom i pauzira kada ne igraš aktivno ili si u drugom prozoru.'
export const TIME_TRACKING_CONSENT_BODY_2 =
  'Ako ti to stvara pritisak, bez pritiska, isključi! Bukvar ostaje ista igra.'
export const TIME_TRACKING_CONSENT_HINT =
  'Ovo uvijek možeš promijeniti u postavkama.'
export const TIME_TRACKING_CONSENT_ENABLE = 'Uključi mjerenje'
export const TIME_TRACKING_CONSENT_DISABLE = 'Ne, hvala'

// Community ("Današnji igrači bukvara") stats
export const COMMUNITY_TITLE = 'Današnji igrači bukvara'
export const COMMUNITY_PLAYED_TEXT = 'igralo danas'
export const COMMUNITY_SOLVE_TIME_TEXT = 'Vrijeme rješavanja'
export const COMMUNITY_AVG_TEXT = 'prosjek danas'
export const COMMUNITY_FASTER_TEXT = (pct: number) =>
  `brži/a si od ${pct}% igrača danas`
export const COMMUNITY_FASTER_SHORT = (pct: number) => `⚡ Brži/a od ${pct}% danas!`
export const COMMUNITY_TIME_OFF_TEXT =
  'Uključi mjerenje vremena da vidiš svoj rang.'
export const COMMUNITY_TRIES_TEXT = 'Šta su drugi probali danas'
export const COMMUNITY_TRIES_HINT = '(osim rješenja)'
export const COMMUNITY_LEGEND_YOU = 'Ti (sve igre)'
export const COMMUNITY_LEGEND_TODAY = 'Danas (ti)'
export const COMMUNITY_LEGEND_ALL = 'Svi danas'

export const SETTINGS_TITLE = 'Postavke'
export const DARK_MODE_TEXT = 'Tamni način'
export const TIME_TRACKING_SETTING_TEXT = 'Mjerenje vremena'
export const TIME_TRACKING_SETTING_DESCRIPTION =
  'Štoperica kreće s prvim slovom i pauzira kada skloniš karticu'
export const REFRESH_SETTING_TEXT = 'Osvježi igru'
export const REFRESH_SETTING_DESCRIPTION =
  'Ne vidiš novu riječ? Osvježi igru ovdje'
